import React, { useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import { Box } from "@mui/material";
import Grid from "@mui/system/Unstable_Grid/Grid";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Nav } from "react-bootstrap";
import { ViewList } from "@mui/icons-material";
import CustomBtn from "../component/customBtns/CustomBtn";
import jwtInterceptor from "../service/jwtInterceptor";
import { LAND_ENDPOINTS } from "../utils/api";
import { useToast } from "../Context/ToastContext";
import { MyLandsMapFilterCard } from "../component/MyLandsMapFilterCard";

const MyLandMapsContainer = () => {
  const DEFAULT_PER_PAGE = 10;
  const DEFAULT_PAGE = 0;

  const searchForm = {
    zoneNoBuilding: "all",
    zoneSpecial: "all",
    areaMin: null,
    areaMax: null,
    isBareLand: false,
    buildingAreaMin: null,
    buildingAreaMax: null,
    buildingYearMin: null,
    buildingYearMax: null,
    sansDate: false,
    renovationMin: null,
    renovationMax: null,
    renovationFinised: false,
    nbNiveauMin: null,
    nbNiveauMax: null,
    logementMin: null,
    logementMax: null,
    propertyOwner: null,
    propertyType: "all",
    proprioForm: "all",
    term: "",
    lands: [],
    location: [],
    owners: [],
    nbProprioMin: null,
    nbProprioMax: null,
    history: "all",
    lastBuildPermit: "all",
    size: 10,
    page: 0,
    region: "all",
  };

  const toaster = useToast();

  const mapsLayout = {
    display: "block",
    height: "100%",
    width: "100%",
    position: "absolute",
    p: 4,
  };

  const switchBtn = {
    position: "fixed",
    top: "2%",
    right: "1%",
    zIndex: 9999
  };

  useEffect(() => {
    // Appliquer overflow hidden au body quand le composant est monté
    document.body.style.overflow = "hidden";
    
    // Restaurer le style original du body quand le composant est démonté
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    jwtInterceptor
      .post(`${LAND_ENDPOINTS.searchMyLands}`, {
        ...searchForm,
        size: DEFAULT_PER_PAGE,
        page: DEFAULT_PAGE,
      })
      .catch((error) => {
        console.log("error in useEffect");
        toaster.notifyError(error.message);
      });
  }, []);

  return (
    <Box className="w-100" sx={{ height: "101vh", position: "relative" }}>
      <Box className="maps-layout" sx={mapsLayout}>
        <Nav.Link as={Link} to="/land"  >
          <CustomBtn
            label="Liste"
            bgColor="#1B208C"
            iconBg={"#1B208C"}
            icon={<ViewList />}
            styles={{ float: "right", ...switchBtn }}
          />
        </Nav.Link>
      </Box>
      <Helmet>
        <title>My Land Maps - Mixdata</title>
      </Helmet>
      <Grid container spacing={2} sx={{ height: "100%" }}>
        <Grid
          className="filters shadow-none"
          xl={3}
          sx={{ position: "absolute" }}
        >
          <Paper className="shadow-none  m-4" style={{ height: "auto" }}>
            <MyLandsMapFilterCard />
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MyLandMapsContainer;
